import { useMe } from '@zep/apis';

import { useAspSessionQuery } from '../services/useAspSessionQuery';

export const useUser = (options?: Parameters<typeof useMe>[0]) => {
  const { data: aspSession } = useAspSessionQuery();
  const query = useMe({
    select: data => data ?? null,
    enabled: !!aspSession,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    retry: false,
    suspense: false,
    useErrorBoundary: false,
    ...options,
  });

  return {
    ...query,
    user: query.data,
  };
};
